import React from 'react'
import { Container, Wrapper } from './styles';
import { Calendar } from '../../components/Calendar';
import { getReservationsList } from '../../services/reservations/getReservations';
import theme from '../../theme/theme';
import Spinner from '../../components/Spinner/Spinner';

const CalendarPage = () => {
  // ------------------- JWT -------------------
  const jwt = localStorage.getItem('jwt');

  const [resourcesList, setResourcesList] = React.useState<any>([]);
  const [eventsList, setEventsList] = React.useState<any>([]);
  const [loadingReservations, setLoadingReservations] = React.useState(false);

  const getUserReservations = async () => {
    try {
      const statuses = ["Pending", "In Progress", "Approved", "Completed", "Not available", "Rejected", "Canceled", "Expired"];
      const allReservations = [];

      for (const status of statuses) {
        const res = await getReservationsList(jwt!, status, "", "");
        if (res && res.data && res.data.length > 0) {
          allReservations.push(...res.data);
        }
      }

      if (allReservations.length > 0) {
        allReservations.sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
        setResourcesList(allReservations);
        createEventsList(allReservations);
      }
    } catch (err) {
      // Manejar el error aquí
    } finally {
      setLoadingReservations(false);
    }
  }

  const createEventsList = (data: any) => {
    let eventsList: any = [];
    data.forEach((resource: any) => {
      let event = {
        title: resource.resource_name,
        start: convertDate(resource.start),
        color: theme.color.pale,
        icon: resource.category_image,
        finish: convertDate(resource.finish),
        category: resource.category,
      }
      eventsList.push(event);
    })
    setEventsList(eventsList);
  }

  const convertDate = (date: string) => {
    if (date === undefined) {
      return "2000-01-01";
    }

    let day = date.split("T")[0];
    return day;
  }

  React.useEffect(() => {
    setLoadingReservations(true);
    getUserReservations();
  }, []);

  return (
    <div>
      {!loadingReservations ? (
        <Wrapper>
          <Container>
            <Calendar events={eventsList} />
          </Container>
        </Wrapper>
      ) : (
        <Spinner />
      )}
    </div>
  )
}

export default CalendarPage